import React, { useEffect, useState } from "react";
import {
  editIcon,
  noLogo,
  searchIcon,
  toggleOff,
  toggleOn,
  viewIcon,
} from "../assets/img";
import { attributeList, decorativeMethodList } from "../redux/api/DummyJson";
import { Search } from "@mui/icons-material";
import CachedIcon from "@mui/icons-material/Cached";
import AddAttributesPopup from "../components/Popup/AddAttributesPopup";
import ImageCroper from "../components/Popup/ImageCroper";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ErrorIcon from "@mui/icons-material/Error";
import {
  useAdminExportsMutation,
  useAttributeCreateMutation,
  useAttributeEditMutation,
  useAttributeListsMutation,
  useLazyAttributeListQuery,
  useLazyAttributeStatusQuery,
  useLazyAttributeViewQuery,
  useLazyOverViewAttributesStatusQuery,
  useOverViewAttributesAddMutation,
  useOverViewAttributesListMutation,
  useOverViewAttributesUpdateMutation,
} from "../redux/api/api";
import { useDispatch } from "react-redux";
import { saveLoader } from "../redux/slice/loaderNoti";

const AttributesPresentationListScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [croper, setCroper] = useState(false);
  const [croperImage, setCropImage] = useState();
  const [list, setList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pageRow, setPageRow] = useState(10);
  const [page, setPage] = useState(1);
  const [pagenation, setPagination] = useState({});
  const [btn, setBtn] = useState(false);
  const [update, setUpdate] = useState({});

  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [nameErr, setNameErr] = useState(false);

  //  RTK QUERY
  const [listAttributeApi] = useLazyAttributeListQuery();
  const [listsAttributeApi] = useOverViewAttributesListMutation();
  const [viewAttributeApi] = useLazyAttributeViewQuery();
  const [createAttributeApi] = useOverViewAttributesAddMutation();
  const [editAttributeApi] = useOverViewAttributesUpdateMutation();
  const [statusAttributeApi] = useLazyOverViewAttributesStatusQuery();
  const [exportsApi] = useAdminExportsMutation();

  const toggleShowPopup = (type) => {
    setShowPopup(!showPopup);
    setName("");
    setImage("");
    setUpdate({});
    setNameErr(false);
    if (type) setPopupType(type);
  };

  const getList = (event, row) => {
    let formdata = new FormData();
    let params = `?page=${page}`;

    formdata.append("type", 9);
    setSearchValue(event);

    if (event?.length > 0) {
      formdata.append("search", event);
    }

    if (row) {
      setPageRow(row);
      formdata.append("rows", row);
    }

    listsAttributeApi({ payload: formdata, params: params })
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          setList(res?.lists);
          setPagination(res?.pagination_meta);
        }
      })
      .catch((err) => {
        console.log("err");
      });
  };

  const change = (id) => {
    statusAttributeApi(id)
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.data?.message || res?.message);
          getList();
        }
      })
      .catch((err) => {
        console.log("err");
      });
  };

  useEffect(() => {
    getList();
  }, [page]);

  const submitHandle = () => {
    if (name?.length == 0) {
      setNameErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("type", 9);

      setBtn(true);
      dispatch(saveLoader(true));
      if (update?.id) {
        editAttributeApi({ payload: formdata, id: update?.id })
          .unwrap()
          .then((res) => {
            setBtn(false);
            dispatch(saveLoader(false));
            toggleShowPopup();
            setName("");
            setImage("");
            setNameErr(false);
            setUpdate({});
            getList();
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      } else {
        createAttributeApi(formdata)
          .unwrap()
          .then((res) => {
            setBtn(false);
            dispatch(saveLoader(false));
            toggleShowPopup();
            setName("");
            setUpdate({});
            setImage("");
            setNameErr(false);
            getList();
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      }
    }
  };

  const getAttribute = (item) => {
    toggleShowPopup("edit");
    setName(item?.name);
    setImage(item?.icon_url);
    setUpdate(item);
  };

  // EXPORT EXCEL
  const getAdminExports = () => {
    let formdata = new FormData();
    formdata.append("type", 22);
    formdata.append("master_type", 9);
    exportsApi(formdata)
      .unwrap()
      .then((res) => {
        if (res?.download_link) {
          const link = document.createElement("a");
          link.href = res?.download_link;
          link.setAttribute("download", "");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <>
      {showPopup && (
        <div className="add-category-popup">
          <div>
            <p className="d-flex ac-jb mt-2 f4 fs-xs-15 fs-sm-16 fs-md-17 fs-lg-18 fs-xl-19 fs-xxl-20 primary">
              {popupType === "edit" ? "Edit" : "Add"} Attribute
              <span>
                <button onClick={toggleShowPopup} className="cust-btn">
                  <HighlightOffIcon />
                </button>
              </span>
            </p>

            <div className="d-flex ac-jc add-content">
              <div className="w-100 d-flex ac-jb mt-4 flex-wrap">
                <p className="f4 fs-xs-13 fs-sm-14 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18 primary">
                  Attribute Name
                </p>
                <div className="w-100 d-flex w-xs-100 mt-xs-5 position-relative">
                  <div className="w-100  w-xs-100 mt-xs-5 position-relative">
                    <input
                      className="w-80 cust-btn searchFill w-xs-100 ms-1 f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15"
                      placeholder="Attribute Name"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                    {name?.length == 0 && nameErr && (
                      <div className="d-flex gap-1 mt-2 position-absolute">
                        <ErrorIcon className="svg_log" />
                        <p className="err-input_log mt-1">Enter Title</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex mt-3 justify-content-end m-2">
              <button
                onClick={submitHandle}
                disabled={btn}
                className={`mt-2 cust-btn addbtn ms-1 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded ${
                  btn && "opacity-50"
                }`}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="dashRightView p-5 home_section trans">
        <div className="d-flex ac-jb mt-2 flex-wrap">
          <p className="f4 fs-sm-21 fs-md-22 fs-lg-23 fs-xl-24 fs-xxl-25 primary">
            Presentation Attributes
          </p>
          <div className="w-100 ac-jb d-flex flex-md-row flex-column mt-4">
            <div className="d-flex">
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15">
                Show
              </p>
              <select
                className="cust-btn f3 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15 ms-1 primary"
                onChange={(e) => getList(searchValue, e.target.value)}
                value={pageRow}
              >
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
              </select>
              <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15 ms-1">
                Entries
              </p>
            </div>
            <div className="d-flex flex-md-row flex-column">
              {/* <div className="d-flex mt-sm-3">
              <img src={searchIcon} className="searchiConImg" alt="icon" />
              <input
                className="cust-btn ms-1 f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15"
                placeholder="Search"
              />
            </div> */}
              <div className="d-flex ac-jb flex-md-row flex-column">
                <p className="f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15 tot-cont me-3 mt-4">
                  Total Count : {pagenation?.total}
                </p>
                <div
                  className="pointerView d-flex mt-4 me-3"
                  role={"button"}
                  onClick={getAdminExports}
                >
                  <GetAppIcon className="primary f1 fs-xs-14 fs-sm-17 fs-md-20 fs-lg-21 fs-xl-22 fs-xxl-23 me-2" />
                  <p
                    className={`gray f3 fs-xs-9 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14`}
                  >
                    Export
                  </p>
                </div>
                <div className="d-flex mt-sm-3 border-search mx-1">
                  <img
                    src={searchIcon}
                    alt="search"
                    className="searchiConImg mt-1"
                  />
                  <input
                    className="cust-btn ms-1 f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-13 fs-xl-14 fs-xxl-15"
                    placeholder="Search"
                    onChange={(e) => getList(e.target.value, pageRow)}
                    value={searchValue}
                  />
                </div>
                <button
                  onClick={() => toggleShowPopup("add")}
                  className="cust-btn addbtn mt-sm-3 ms-1 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded"
                >
                  + Add Attribute
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5" style={{ width: "100%", overflow: "auto" }}>
          <table className="table-design-new" style={{ width: "100%" }}>
            <thead>
              <tr className="border-bottom w-100">
                <th>
                  <p className="w-100 f2 fs-15 fs-xs-16 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-15 d-flex as-jc">
                    S.No
                  </p>
                </th>

                <th>
                  <p className="w-100 f2 fs-15 fs-xs-16 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-15 d-flex as-jc">
                    Attribute Name
                  </p>
                </th>
                <th>
                  {" "}
                  <p className="w-100 f2 fs-15 fs-xs-16 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-15 d-flex as-jc">
                    Status
                  </p>
                </th>
                <th>
                  {" "}
                  <p className="w-100 f2 fs-15 fs-xs-16 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-15 d-flex as-jc">
                    Action
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.map((item, index) => {
                return (
                  <tr>
                    <td>
                      <p className="pointerView f2 fs-15 fs-xs-16 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-16 d-flex ac-jc primary1">
                        {index + 1}
                      </p>
                    </td>

                    <td>
                      <p className="pointerView  f2 fs-15 fs-xs-16 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-16 d-flex ac-jc primary1 text-capitalize">
                        {item?.name}
                      </p>
                    </td>
                    <td>
                      <div
                        className="d-flex ac-jc"
                        onClick={() => change(item?.id)}
                      >
                        {item?.status === 1 ? (
                          <div>
                            <img src={toggleOn} className="toggleOnDes" />
                          </div>
                        ) : (
                          <div>
                            <img src={toggleOff} className="toggleOnDes" />
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div
                        onClick={() => getAttribute(item)}
                        className="ms-2 p-2 bg-white rounded-2 d-flex justify-content-center"
                      >
                        <img src={editIcon} className="viewDes" alt="icon" />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between mt-3">
          <button
            className={`cust-btn addbtn mt-sm-3 ms-1 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded ${
              page == 1 && "opacity-50"
            }`}
            onClick={() => setPage(page - 1)}
            disabled={page == 1 ? true : false}
          >
            Previous
          </button>
          <button
            className={`cust-btn addbtn mt-sm-3 ms-1 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded ${
              page == pagenation?.last_page && "opacity-50"
            }`}
            onClick={() => setPage(page + 1)}
            disabled={page == pagenation?.last_page ? true : false}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default AttributesPresentationListScreen;
